import Smartlook from 'smartlook-client';

export const loadSmartlook = () => {
  if (!process.env.GATSBY_SMARTLOOK_KEY) return;

  Smartlook.init(process.env.GATSBY_SMARTLOOK_KEY, {
    cookies: false,
  });

  // We explicitly exclude elements with https://web.developer.smartlook.com/docs/masking-rules#excluding-elements
  Smartlook.record({
    forms: true,
    numbers: true,
  });
};
